import React, { createContext, useContext, useState } from "react";

interface PageNameContextInterface {
  pageInfo: {
    name: string;
    desc: string;
  };
  setInfo: React.Dispatch<
    React.SetStateAction<{
      name: string;
      desc: string;
    }>
  >;
}

interface PageNameProviderInterface {
  children: React.ReactNode;
}

const PageNameContext = createContext<PageNameContextInterface>({
  pageInfo: {
    name: "Dashboard",
    desc: "A quick glance at the current status of your business",
  },
  setInfo: () => {},
});

export function PageNameProvider({ children }: PageNameProviderInterface) {
  const [pageInfo, setPageInfo] = useState({
    name: "Dashboard",
    desc: "A quick glance at the current status of your business",
  });

  return (
    <PageNameContext.Provider
      value={{ pageInfo: pageInfo, setInfo: setPageInfo }}
    >
      {children}
    </PageNameContext.Provider>
  );
}

export function usePageNameContext() {
  const pageNameCtx = useContext(PageNameContext);

  if (!pageNameCtx) {
    throw new Error(
      "usePageNameContext must be used within a PageNameProvider"
    );
  }

  const _setInfo = (info: { name: string; desc: string }) => {
    pageNameCtx.setInfo(info);
    document.title = `Wilma | ${info.name}`
  }

  return {...pageNameCtx, setInfo: _setInfo};
}
